import { defineHeroThemeContract, type HeroThemeTokens } from '../../../art/contract';

/**
 * The sleuth hero's THEME (ADR-0099 / ADR-0102 / ADR-0117) — a warm tan + investigator-teal palette pulled from
 * her painted art, with a bright magnifier-red accent and a soft dusk-blue "case at nightfall" sky (her own
 * world). Choosing her recolours the WHOLE kid shell: the brand ramp drives buttons / meters / rings in teal,
 * the canvas warms to a tan+teal dawn, and the hero stage takes her dusk-blue sky. Every brand colour is paired
 * with its own foreground for legibility.
 */
export const sleuthTheme: HeroThemeTokens = defineHeroThemeContract({
  // BRAND RAMP — investigator teal. `soft`→`primary` is the button/meter gradient (white text); `deep` is
  // on-light text (≈ 7:1 on the light kid surfaces); `tint` is the softest fill; `glow-rgb` = #25817D.
  '--color-primary': '#25817D',
  '--color-primary-fg': '#FFFFFF',
  '--color-primary-soft': '#3FA29D',
  '--color-primary-deep': '#1C6C68',
  '--color-primary-tint': '#DEF3F1',
  '--color-primary-glow-rgb': '37 129 125',
  '--color-secondary': '#F0E3CE',
  '--color-secondary-fg': '#5B4A2E',
  // magnifier-red accent with a near-black leather ink (white on this red held only ~3.6:1).
  '--color-accent': '#E8563F',
  '--color-accent-fg': '#2E0B04',
  // CANVAS — a warm tan bloom top-left, a soft teal bloom bottom-right (a cosy case-file dawn behind content).
  '--canvas-a': '#F5E7CF',
  '--canvas-b': '#DCF1EF',
  // A soft dusk-blue "case at nightfall" sky (white text stays AA over it).
  '--sky-top': '#1e2a44',
  '--sky-mid': '#33507a',
  '--sky-low': '#7fa3c4',
  '--sky-glow': '#f2d6b0',
  '--sky-fg': '#ffffff',
});
